export default {
  // Haupt-Hero-Block auf der Startseite
  title_1: 'Internationale Plattform zur Immobilienbewertung',
  title_2: 'Finden Sie Immobilien unter dem Marktpreis',
  lead_1: 'Bewertung, Prognose und Vergleich von Objekten mit KI – alles an einem Ort',
  lead_2: 'Moderne Algorithmen: Lineare Regression, Random Forest, Neuronales Netzwerk',
  lead_3: 'Für Investoren, Bauträger, Agenturen und Immobilienverkäufer',
  login_btn: 'Einloggen',

  // Überschriften für Hero auf anderen Seiten
  title_property: 'Immobilienobjekt',
  title_properties: 'Immobilienkatalog',
  title_developer: 'Profil des Bauträgers',
  title_developers: 'Alle Bauträger',
  title_agency: 'Profil der Agentur',
  title_agencies: 'Immobilienagenturen',
  title_news: 'Nachrichten und Analysen',
  title_news_item: 'Nachrichtendetails',
  title_residential_complex: 'Wohnanlage',
  title_district: 'Informationen zum Stadtteil',
  title_statistics: 'Marktstatistik',
  title_about: 'Über das Projekt Estimator24',

  // Breadcrumbs
  breadcrumbs: {
    home: 'Startseite',
    properties: 'Alle Objekte',
    developers: 'Bauträger',
    agencies: 'Agenturen',
    news: 'Nachrichten',
    statistics: 'Statistik',
    about: 'Über das Projekt'
  }
}
